module.exports = __webpack_public_path__ + "logo.bec365f57ef20720dc2c.png";


//////////////////
// WEBPACK FOOTER
// D:/inetpub/wwwroot/kaizen-ng/src/assets/img/logo.png
// module id = ../../../../../src/assets/img/logo.png
// module chunks = styles